/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 臻享卡卡片根据场景分发不同的视图主入口文件
*/
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApplyChannelData, EquityPathType } from '@/api/apply-product/types';
import { HoldModel } from '@/shared/decorators/hold-model';
import {
  LoanRightStateType, SpeedRightsType,
} from '@/views_v2/apply-product/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { PricingTypeEnum } from '@/enums/rights';
import { CloseOutline16 } from '@hb/coffee-icons';
import AllRightsCard from './hello-app/allRightsCard';

import DetailPagePopup from './components/rights-popup';
import { getDetailUrl } from './utils/getDetailUrl';
import style from './index.module.scss';

const ApplyProductStore = namespace('applyProduct');
const LoanRightStore = namespace('loanRight');

@Component
export default class ZhenXiangCard extends Vue {
  // 是否h5外采活体回跳
  @Prop(Boolean) readonly h5Bio!: boolean;

  // 是否一键绑卡回跳
  @Prop(Object) quickBindCardResult!: Dictionary;

  // 权益类型
  @Prop(Number) readonly pricingType?: PricingTypeEnum;

  @ApplyProductStore.State channel!: ApplyChannelData | undefined;

  @ApplyProductStore.State channelList!: ApplyChannelData[];

  @ApplyProductStore.State amount!: string;

  @LoanRightStore.State rightParams!: LoanRightStateType['rightParams'];

  @LoanRightStore.State showSpeed!: LoanRightStateType['showSpeed'];

  @ApplyProductStore.Getter isDoublePassageDefaultSelectNormal!: boolean;

  /** 是否需要购买权益 */
  @ApplyProductStore.Getter needBuyRight!: boolean;

  /** 是否需要购买臻享会员 */
  @ApplyProductStore.Getter needBuyZhenxiangMember!: boolean;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @LoanRightStore.Action('$updateState') updateLoanRightState!: (data: Dictionary) => void;


  @ApplyProductStore.State is24NeedRightAndNormalIs36!: boolean;


  @HoldModel()
  private rightscheckTipsShow!: boolean;

  public isDetailPopShow = false;

  /** 权益详情页访问地址 */
  private rightsUrl = '';

  /** 是否展示未开通权益详情页 */
  private showUnopenedDetailUrl = false;

  /** 是否展示测试挽留弹窗 */
  public autarkyRetainRightsPopupShow = false;

  private showClose= true;

  /** 获取渲染实例 */
  public get zhenXiangCardInstance(): AllRightsCard {
    return this.$refs.allRightsCard as AllRightsCard;
  }

  public get equatyValue(): EquityPathType {
    // 根据当前场景，获取equatyValue，存在定价标签
    const equityPath = this.zhenXiangCardInstance.equatyValue;
    // 定价标签为5 && equityPath为''时，改为2
    // 为了和自营保持一致，这块的逻辑计算比较复杂后续不应该放在前端维护
    return equityPath;
  }

  public get canSubmitOrder(): boolean {
    return this.zhenXiangCardInstance.canSubmitOrder;
  }

  public get tqParams(): Dictionary {
    return this.zhenXiangCardInstance?.tqParams || {};
  }

  public get isChecked(): boolean {
    return this.zhenXiangCardInstance.isChecked;
  }

  public onClosedRightsPopup(): void {
    this.$ubtPageButtonNew('fincance_inloan_detail_close', this.tqParams);
    this.isDetailPopShow = false;
  }

  /** 提交订单 */
  private onSubmitClick() {
    this.$emit('submitClick');
  }

  private showRightsDetail() {
    // this.$ubtPageButtonNew('fincance_inloan_detail_click', this.tqParams);
    // 查看权益详情
    if (this.rightParams) {
      this.showUnopenedDetailUrl = !!this.rightParams.unopenedDetailUrl;
      const rightsUrl = getDetailUrl(
        {
          channelInfo: this.channel,
          rightParams: this.rightParams,
        },
      );

      if (!rightsUrl) {
        return;
      }

      this.rightsUrl = rightsUrl;
      this.isDetailPopShow = true;
    } else {
      ubtSendError('need show detail but hasnt rightdata');
    }
  }

  /** 切换权益tab时，主要是为了24+权益切换tab时需要重新请求试算接口，向外抛出钩子 */
  private onRightTabChange(type: SpeedRightsType) {
    /**
     *  24+单通道普通通道切换到轻资产场景，无需抛出切换权益tab事件
     * 当前外层监听切换权益tab事件，切换权益tab事件会重新请求试算接口，所以此处场景需要排除在外
     */
    if (!this.is24NeedRightAndNormalIs36) {
      this.$emit('rightTabChange', type);
    }
  }

  private renderCard() {
    return (
      <AllRightsCard
        ref="allRightsCard"
        v-model={this.rightscheckTipsShow}
        h5Bio={this.h5Bio}
        pricingType={this.pricingType}
        quickBindCardResult={this.quickBindCardResult}
        onShowRightsDetail={this.showRightsDetail.bind(this)}
        onRightTabChange={this.onRightTabChange.bind(this)}
        onSubmitClick={this.onSubmitClick.bind(this)}
        />
    );
  }

  private render() {
    return (
      <div>
        {this.renderCard()}
        {/** 权益详情弹窗 */}
        <DetailPagePopup
          v-model={this.isDetailPopShow}
          onclose={this.onClosedRightsPopup.bind(this)}
          rightsUrl={this.rightsUrl}
          showUnopenedDetailUrl={this.showUnopenedDetailUrl}
          popupTitle={this.showUnopenedDetailUrl ? '' : '臻享权益'}
          fullScreen={false}
          onChangeClose={(closeStatus: boolean) => { this.showClose = closeStatus; }}
        >
          {this.needBuyZhenxiangMember && (<template slot="header">
            <div class={style.zhenxiangMemberWrapper}>
              {this.showClose && (<CloseOutline16
                class={style.zhenxiangMemberClose}
                color={'#e2c5ab'}
                onClick={this.onClosedRightsPopup.bind(this)}>
              </CloseOutline16>)}
            </div>
          </template>)}

          {this.needBuyRight && (<template slot="header">
            <div class={style.zhenxiangCard}>
              {this.showClose && (<CloseOutline16
                class={style.zhenxiangCardClose}
                onClick={this.onClosedRightsPopup.bind(this)}>
              </CloseOutline16>)}
            </div>
          </template>)}
        </DetailPagePopup>
      </div>
    );
  }
}
